import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logoPBlack from '../../images/logo/pd-mark.svg';
import styles from '../PageLayout/PageLayout.module.scss';
import { LanguageSelect } from '../LanguageSelect';
import ProfileMenu from '../ProfileMenu';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { AdminToggle } from '../AdminToggle';
import useUser from '../../Hooks/useUser';
import { useNav } from '../../Context/Navigation';
import { ImpersonateView } from '../ImpersonateView';

export const UpperNav = ({ setMobileSidebarOpen }) => {
  const { currentPage } = useNav();
  const { currentUser, impersonateEmail } = useUser();
  const { t } = useTranslation();
  const showAdminToggle = impersonateEmail === '' && currentUser?.role === 'admin';

  return (
    <div className="sticky top-0 z-40 flex flex-col border-b border-gray-200 bg-white">
      {impersonateEmail && (
        <div className="w-full">
          <ImpersonateView />
        </div>
      )}

      <div className="flex h-25 shrink-0 items-center gap-x-4 px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:h-auto lg:px-8 lg:shadow-none">
        <div aria-hidden="true" className="h-6 bg-gray-200 lg:hidden" />

        <div className="flex flex-1 gap-x-4 self-stretch lg:justify-between lg:py-8">
          <Link to={'/'} className="self-center lg:hidden">
            <div className="flex">
              <img alt="Pure Desire Ministries" src={logoPBlack} className="mr-2 h-14 text-white" />
            </div>
          </Link>
          <div className="align-items-center flex items-center">
            <div className="flex sm:space-x-8 lg:ml-6">
              <span data-testid='current-page-title' className={`${styles.page_title} text-4xl lg:text-5xl`}>{t(currentPage)}</span>
            </div>
          </div>
          <div className="hidden items-center gap-x-4 lg:flex lg:gap-x-6">
            {showAdminToggle && <AdminToggle fontSize={'text-2xl'} />}
            <LanguageSelect />
            <ProfileMenu />
          </div>
        </div>

        <button
          type="button"
          onClick={() => setMobileSidebarOpen(true)}
          className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
        >
          <span className="sr-only">Open sidebar</span>
          <Bars3Icon aria-hidden="true" className="mx-2 size-10" />
        </button>
      </div>
    </div>
  );
};
